<template>
  <div class="videoExamine-box">
    <!--操作栏-->
    <div class="action-bar">
      是否付费：
      <el-select
        v-model="params.isFree"
        placeholder="是否付费"
        size="small"
        @change="getVideoList('status')"
        clearable
      >
        <el-option
          v-for="item in isPay"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option> </el-select
      >是否马甲账号:
      <el-select
        v-model.number="params.isPretendAcc"
        placeholder="是否马甲账号"
        size="small"
        @change="getVideoList('status')"
        clearable
      >
        <el-option
          v-for="item in isVest"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option> </el-select
      >帖子类型:
      <el-select
        v-model.number="params.newsType"
        placeholder="帖子类型"
        size="small"
        @change="getVideoList('status')"
        clearable
      >
        <el-option label="全部" :value="0"></el-option>
        <el-option label="长视频" :value="5"></el-option>
        <el-option label="短视频" :value="6"></el-option>
        <el-option label="视频" :value="1"></el-option>
        <el-option label="图集" :value="2"></el-option>
        <el-option label="种子贴子" :value="7"></el-option>
        <el-option label="黄游帖子" :value="8"></el-option>
        <el-option label="视频广告" :value="3"></el-option>
        <el-option label="图片广告" :value="4"></el-option>
      </el-select>
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        size="small"
        class="param-input"
        @change="getVideoList('status')"
        clearable
      ></el-input>
      <el-input
        v-model="params.id"
        placeholder="请输入帖子ID"
        clearable
        @change="getVideoList('status')"
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.title"
        placeholder="请输入帖子标题"
        size="small"
        class="param-input"
        @change="getVideoList('status')"
        clearable
      ></el-input>
      <el-button type="primary" size="small" @click="getVideoList()"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="examine('many')"
        >批量审核</el-button
      >
      <el-button type="primary" size="small" @click="batchEditTag()"
        >批量修改标签</el-button
      >
      <el-button type="primary" size="small" @click="addVideo()"
        >+新增帖子</el-button
      >
      <el-button type="primary" size="small" @click="examineAll()"
        >查看当前列表所有帖子</el-button
      >
      <el-button type="primary" size="small" @click="openConfiguration('vid')"
        >审核不通过原因配置</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      height="550"
    >
      <el-table-column type="selection" align="center" fixed></el-table-column>
      <el-table-column label="用户ID" align="center" width="160" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="UP主ID" align="center" width="160" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.vlogger_user_id || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="帖子ID"
        align="center"
        width="220"
      ></el-table-column>

      <el-table-column
        prop="newsType"
        label="帖子类型"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.newsType | getNewsTypeName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="视频标题"
        align="center"
        :show-overflow-tooltip="true"
        width="250"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="视频内容"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content || "-" }}</span>
        </template>
      </el-table-column>

      <!--
      <el-table-column prop="isFree" label="是否免费" align="center" width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isFree" disabled size="small"></el-switch>
        </template>
      </el-table-column>
      -->
      <el-table-column
        label="封面图"
        align="center"
        width="120"
        prop="coverThumb"
      >
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="checkUrl(scope.row.cover) + scope.row.cover"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="视频审查" align="center" width="100">
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.sourceURL, 'video', scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="原视频下载" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            @click="downloadMedia(scope.row.id)"
            v-if="scope.row.newsType === 'SP' || scope.row.newsType === 'MOVIE'"
          >
            <i class="el-icon-download" title="原视频下载"></i>
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="是否为精选" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.chosen"
            @change="setChosen(scope.row, 'chosen')"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="userName"
        label="用户昵称"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.name || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userImage"
        label="用户头像"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="
              checkUrl(scope.row.publisher.portrait) +
                scope.row.publisher.portrait
            "
          ></img-load>
        </template>
      </el-table-column>

      <el-table-column
        prop="activityId"
        label="活动ID"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="
              scope.row.activityId == '000000000000000000000000' ||
                !scope.row.activityId
            "
            >不参加活动</el-tag
          >
          <span v-else>{{ scope.row.activityId }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length"
            >未知</span
          >
          <div
            v-else
            class="picturePreview"
            @click="previewPicture(scope.row.seriesCover, scope.row.id)"
          >
            <el-image
              style="width: 50px; height: 50px"
              :src="checkUrl(item) + item"
              fit="fill"
              v-for="(item, i) in scope.row.seriesCover"
              :key="i"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="size"
        label="视频大小(M)"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.size / 1024 / 1024) | transformFloat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="playTime"
        label="总时长"
        align="center"
        width="130"
        :sortable="'custom'"
      >
        <template slot-scope="scope">{{
          scope.row.playTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column
        prop="freeTime"
        label="免费时长"
        align="center"
        width="130"
        :sortable="'custom'"
      >
        <template slot-scope="scope">{{
          scope.row.freeTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column label="免费/收费" align="center" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.vipOrCoin">
            <span>{{ `免费: ${scope.row.vipCount}` }}</span>
            <br />
            <span>{{ `收费: ${scope.row.coinCount}` }}</span>
          </div>
          <el-button
            v-else
            type="success"
            size="mini"
            @click="getVipOrCoinCount(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="coins"
        label="价格"
        align="center"
        width="100"
        :sortable="'custom'"
      ></el-table-column>

      <el-table-column prop="tags" label="标签" align="center" min-width="250">
        <template slot-scope="scope">
          <el-tag
            type="success"
            size="mini"
            effect="plain"
            class="tags"
            v-for="(tag, i) in scope.row.tags"
            :key="i"
            >{{ "#" + tag.name }}</el-tag
          >
          <i
            class="el-icon-edit edit"
            @click="editTag(scope.row, scope.row.picture)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="tags"
        label="父专题"
        align="center"
        min-width="250"
      >
        <template slot-scope="scope">
          <el-tag
            type="success"
            size="mini"
            effect="plain"
            class="tags"
            v-for="item in scope.row.sectionName"
            :key="item.SectionModName"
            >{{ item.SectionModName }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="tags"
        label="子专题"
        align="center"
        min-width="250"
      >
        <template slot-scope="scope">
          <el-tag
            type="success"
            size="mini"
            effect="plain"
            class="tags"
            v-for="item in scope.row.sectionName"
            :key="item.SectionsId"
            >{{ item.SectionName }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="上传时间"
        align="center"
        width="160"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="当前状态"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">未审核</span>
          <span v-if="scope.row.status === 2">未通过</span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否可推荐"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.recoWeight === 0 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="250">
        <template slot-scope="scope">
          <!-- <el-tooltip class="item" effect="dark" content="审核" placement="top" v-if="userInfo.admin.role !== '公共资源'">
            <el-button type="success" size="mini" class="el-icon-check" @click="examineOne(scope.row)"></el-button>
          </el-tooltip>-->
          <el-button type="success" size="mini" @click="approved(scope.row)"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="passButton(scope.row, 'vid')"
            >不通过</el-button
          >
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="editVideo(scope.row)"
          ></el-button>
          <!-- <el-button type="danger" size="mini" class="el-icon-delete" @click="removeVideo(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 5"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <!--标签话题编辑弹窗-->
    <tags-popup
      ref="tagsPopup"
      @handlerVideoList="handlerVideoList"
    ></tags-popup>
    <!-- 审核不通过理由弹窗 -->
    <reason-action ref="reasonAction" />
    <!--批量审核弹窗-->
    <examine-popup
      ref="examinePopup"
      @handlerExamine="handlerExamine"
    ></examine-popup>
    <select-reason ref="selectReason" @handleList="getVideoList()" />
    <!--新增视频-->
    <add-video ref="addVideo" @handlerLoadList="handlerLoadList"></add-video>
    <!-- 编辑视频 -->
    <edit-video ref="editVideo" @handlerEditList="handlerEditList"></edit-video>
    <!--审核当前界面所有视频-->
    <examine-all ref="examineAll"></examine-all>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
    <el-dialog
      title="加入专题"
      :visible.sync="isAddSection"
      width="550px"
      :before-close="handleClose"
    >
      <div class="topicBox">
        <el-select
          v-model="searchSubSections"
          placeholder="请选择父专题"
          size="small"
          clearable
          @change="searchSelectSection"
        >
          <el-option
            v-for="(section, index) in sections"
            :key="index"
            :label="section.subModuleName"
            :value="section.sections"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="sectionID"
          placeholder="请选择子专题"
          size="small"
          clearable
          style="width:280px"
        >
          <el-option
            v-for="(subSection, index) in searchSubSections"
            :key="index"
            :label="subSection.sectionName"
            :value="subSection.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="onSubmmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--批量标签话题编辑弹窗-->
    <batch-tags-popup
      ref="batchTagsPopup"
      @handlerClose="handleClose"
    ></batch-tags-popup>
  </div>
</template>
<script>
import PreviewVideo from "./components/preview-video";
import TagsPopup from "./components/tags-popup";
import ExaminePopup from "./components/examine-popup";
import AddVideo from "./components/add-video.vue";
import EditVideo from "./components/edit-video";
import ExamineAll from "./components/examine-all";
import API from "@/api";
import { sortEscape } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import PreviewPicture from "./components/previewPicture";
import ReasonAction from "@/components/reasonAction";
import SelectReason from "@/components/selectReasonAction";
import BatchTagsPopup from "@/components/batchTagsPopup";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      imgUrl: baseConfig.imgUrl,
      newImgUrl: baseConfig.newImgUrl,
      userInfo: local.get("userInfo"),
      listUrl: [],
      sections: [],
      sectionID: undefined,
      searchSubSections: "",
      isAddSection: false,
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: 0,
        isFree: 2,
        isPretendAcc: 0,
        key: "createdAt",
        newsType: 0,
        value: "1",
        title: "",
        uid: "",
        id: "",
      },
      // 是否免费
      isPay: [
        {
          label: "全部",
          value: 2,
        },
        {
          label: "是",
          value: 0,
        },
        {
          label: "否",
          value: 1,
        },
      ],
      // 是否是马甲账号
      isVest: [
        {
          label: "所有",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      // 被勾选(审核)的数据
      checkedData: [],
      // 列表数据
      tableData: [],
    };
  },
  components: {
    PreviewVideo,
    TagsPopup,
    ExaminePopup,
    AddVideo,
    EditVideo,
    ExamineAll,
    PreviewPicture,
    ReasonAction,
    SelectReason,
    BatchTagsPopup,
  },
  created() {
    this.getVideoList();
  },
  methods: {
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
    // 是否为精选
    setChosen(row, type) {
      if (type === "chosen") {
        // 视频精选
        row.chosen = !row.chosen;
        let text = row.chosen
          ? "您确定要取消当前视频的精选推送吗？"
          : "您确定要推送当前视频至精选吗？";
        this.$confirm(text, "推送提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              ids: [row.id],
              field: "chosen",
              status: !row.chosen,
            };
            API.setChosen(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: params.status
                    ? "推送至精选成功！"
                    : "取消精选成功！",
                  type: "success",
                });
                this.getVideoList();
              } else {
                this.$message.error("推送至精选失败！");
              }
            });
          })
          .catch(() => {});
      }
    },
    handlerPreviewList() {
      this.getVideoList();
    },
    // 获取视频列表
    getVideoList(type, tempPageNumber) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      if (tempPageNumber) {
        this.params.pageNumber = tempPageNumber;
      }
      this.loading = true;
      API.getVideoList(this.params)
        .then((res) => {
          if (res.code === 200) {
            // 处理审核完最后一页没有数据展示
            if (!res.data.vInfos && res.data.total > 0) {
              this.getVideoList("", this.params.pageNumber - 1);
            }
            this.tableData = res.data.vInfos;
            this.total = res.data.total;
            if (this.listUrl.length > 0) {
              this.listUrl = [];
            }
            this.tableData.forEach((item) => {
              this.listUrl.push({ url: item.sourceURL, title: item.title });
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 下载原视频
    downloadMedia(id) {
      let param = {};
      API.videoFeviewList(param, id).then((res) => {
        let href = baseConfig.downLoadUrl + res.data.fileName;
        window.open(href);
      });
    },
    onSubmmit() {
      this.isAddSection = false;
      if (this.type === "pass") {
        let params = {
          ids: [this.video.id],
          pass: 1,
          reason: "",
          sectionID: this.sectionID,
        };
        this.examineVideo(params);
      }
      // if (this.type === "auto") {
      //   API.addVidTimeOnline({
      //     vidId: this.video.id,
      //     sectionID: this.sectionID,
      //   })
      //     .then((res) => {
      //       if (res.code === 200) {
      //         this.$message({
      //           message: "设置成功！",
      //           type: "success",
      //         });
      //       } else {
      //         this.$message.error("设置失败！");
      //       }
      //       this.flag = false;
      //       this.handleClose();
      //       this.getVideoList();
      //     })
      //     .catch(() => {
      //       this.flag = false;
      //     });
      // }
    },
    // 通过审核
    approved(video) {
      if (video.newsType === "MOVIE") {
        this.isAddSection = true;
        this.getAllSections();
        this.video = video;
        this.type = "pass";
      } else {
        let params = {
          ids: [video.id],
          pass: 1,
          reason: "",
        };
        this.examineVideo(params);
      }
    },
    getAllSections() {
      API.sectionList({}).then((res) => {
        if (res && res.code === 200) {
          this.sections = res.data;
        }
      });
    },
    searchSelectSection() {
      this.sectionID = "";
    },
    // 审核请求
    examineVideo(params) {
      API.examineVideo(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("操作失败！");
          }
        })
        .catch(() => {
          this.$message.error("操作失败！");
        });
    },
    // 点击不通过按钮
    passButton(row, type) {
      this.$refs.selectReason.open(row, type);
    },
    // 图集预览
    previewPicture(pictureArr, id) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    // up主vip金币视频数量预览
    getVipOrCoinCount(row) {
      API.getVipAndCoin({ uid: row.publisher.uid }).then((res) => {
        row.vipCount = res.data.vipCount;
        row.coinCount = res.data.coinCount;
        this.$set(row, "vipOrCoin", true);
      });
    },
    // 获取不通过理由列表
    queryFailList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.reasonLoading = true;
      API.queryFailList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            res.data.list.forEach((item) => {
              item.isClisk = false;
            });
            this.reasonTableData = res.data.list;
            this.reasonTotal = res.data.total;
          } else {
            this.reasonTableData = [];
            this.reasonTotal = 0;
          }
          this.reasonLoading = false;
        })
        .catch(() => {
          this.reasonTableData = [];
          this.reasonLoading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideoList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getVideoList();
    },
    // 新增视频成功回调
    handlerLoadList() {
      this.getVideoList();
    },
    // 编辑视频成功回掉
    handlerEditList() {
      this.getVideoList();
    },
    // 审核结果回调
    handlerExamine() {
      this.getVideoList();
    },
    // 不通过理由列表回掉
    handlerConfigurationList() {
      this.getVideoList();
    },
    // 排序回掉
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getVideoList();
    },
    // 监听标签编辑回调
    handlerVideoList() {
      this.getVideoList();
    },
    // 视频查看
    checkMedia(url, type, data) {
      if (url.slice(0, 1) == "/") {
        url = url.slice(1);
      }
      console.log(url);
      this.$refs.previewVideo.open(url, type, data);
    },
    // 编辑标签
    editTag(row, pic) {
      this.$refs.tagsPopup.open(row, pic);
    },
    // 进行数据勾选时触发事件
    handleSelectionChange(row) {
      this.checkedData = row;
    },
    // 取消选择
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 点击审核
    examine(type) {
      if (type === "many" && this.checkedData.length === 0) {
        this.$message.error("请至少选择一条信息进行审核");
        return;
      }
      if (type === "many" && this.checkedData.length > 10) {
        this.$message.error("审核的条数不能超过10条");
        return;
      }
      let checkedData1 = JSON.parse(JSON.stringify(this.checkedData));
      this.$refs.examinePopup.open(checkedData1, type);
      this.toggleSelection();
    },
    batchEditTag() {
      if (this.checkedData.length === 0) {
        this.$message.error("请至少选择一条信息进行修改");
        return;
      }
      let checkedData1 = JSON.parse(JSON.stringify(this.checkedData));
      const videoIds = checkedData1.map((item) => item.id);
      this.$refs.batchTagsPopup.open(videoIds);
    },
    // 单条审核
    // examineOne(row) {
    //   // 设置为空避免下次打开弹窗时会记录上次数据
    //   this.checkedData = []
    //   this.checkedData.push(row)
    //   this.examine('single')
    //   // 设置为空避免点击取消时会记录上次数据
    //   this.checkedData = []
    // },
    // 删除视频
    // removeVideo(id) {
    //   this.$confirm('您确定要删除当当前视频吗？', '删除提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     API.deleteVideo({ ids: [id] }).then(res => {
    //       if (res.code === 200) {
    //         this.$message({
    //           message: '删除成功',
    //           type: 'success'
    //         });
    //         this.getVideoList()
    //       } else {
    //         this.$message.error('删除失败！');
    //       }
    //     })
    //   })
    // },
    // 新增视频
    addVideo() {
      this.$refs.addVideo.open();
    },
    // 编辑视频
    editVideo(row) {
      // row.size = (row.size/1024/1024).toFixed(2)
      this.$refs.editVideo.open(row);
    },
    // 审核全部视频
    examineAll() {
      this.$refs.examineAll.open(this.listUrl);
    },
    // 审核不通过理由配置
    openConfiguration(type) {
      this.$refs.reasonAction.open(type);
    },
    // 关闭弹窗
    handleClose() {
      this.sections = [];
      this.video = null;
      this.type = undefined;
      this.sectionID = undefined;
      this.subSections = [];
      this.searchSubSections = "";
      this.isAddSection = false;
      this.isBatchAutoShelves = false;
      this.getVideoList();
    },
  },
};
</script>

<style lang="scss">
.videoExamine-box {
  .views {
    font-size: 20px;
    color: #e63765;
    cursor: pointer;
    &:hover {
      color: #eb5f84;
    }
  }
  .edit {
    font-size: 18px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .cell {
    overflow: hidden;
  }
  .tags {
    font-size: 12px;
    margin-right: 5px;
  }
  .action-bar {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #666;
    margin-bottom: 50px !important;
    .el-select {
      width: 150px;
      margin-right: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
    .block {
      margin-top: 30px;
    }
    .param-input {
      width: 180px;
      margin-right: 10px;
    }
  }
  .picturePreview {
    max-width: 300px;
    display: flex;
  }
  .topicBox {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 20px;
    .sort {
      width: 80px;
    }
  }
}
</style>
